export default "__VITE_PUBLIC_ASSET__d40a7a95__"